<template>
  <div class="HomePage">
    <!-- <div id="app">
      <h1>{{ $t("message.hello") }}</h1>
      <button @click="changeLanguage('zh')">中文</button>
      <button @click="changeLanguage('ja')">日本語</button>
    </div> -->
    <div class="con_box">
      <div class="top_box" @click="toHome">
        <div class="top_img">
          <img src="../assets/logo.jpg" alt="" />
        </div>
        <div class="top_rig">
          <div @click="toGaiyao" class="tab">{{ $t("home.h2") }}</div>
          <div @click="tojieshao" class="tab">{{ $t("home.h3") }}</div>
          <div @click="toshiji" class="tab">{{ $t("home.h4") }}</div>
          <div @click="towenxun" class="tab">{{ $t("home.h5") }}</div>
          <!-- <select v-model="selectedOption" @change="handleChange">
            <option disabled value="">请选择</option>
            <option>中文</option>
            <option>日本語</option>
          </select> -->
        </div>
      </div>
      <div class="bg_img">
        <img src="../assets/bg.png" alt="" />
      </div>
      <div class="h_title">
        <div style="font-size: 20px">詳しく見る→</div>
        <div @click="tojieshao" class="hudong_title">
          インターンシップ事業紹介
        </div>
      </div>
      <div class="img_h1">
        <img src="../assets/h10.jpg" alt="" />
        <div class="meng_h1">
          <div @click="toGaiyao"></div>
          <div @click="tojieshao"></div>
          <div @click="toshiji"></div>
          <div @click="towenxun"></div>
        </div>
      </div>
      <div class="img_h2">
        <img src="../assets/h2.png" alt="" />
        <div class="meng_h2">
          <div @click="tojieshao"></div>
          <div @click="toshiji"></div>
          <div @click="tojieshao"></div>
          <div @click="toGaiyao"></div>
          <div @click="tojieshao"></div>
          <div @click="toshiji"></div>
          <div @click="tojieshao"></div>
          <div @click="tojieshao"></div>
          <div @click="toGaiyao"></div>
        </div>
      </div>
      <!-- <div class="gaiyao_title">{{ $t("home.h7") }}</div>
      <div class="biao">
        <div class="biao_le biao_le_1">{{ $t("home.h8") }}</div>
        <div class="biao_rig biao_rig_1">
          <div>{{ $t("home.h9") }}</div>
          <div>{{ $t("home.h10") }}</div>
        </div>
      </div>
      <div class="biao biao1">
        <div class="biao_le biao_le1 biao_le2">
          <div>{{ $t("home.h11") }}</div>
          <div>{{ $t("home.h12") }}</div>
        </div>
        <div class="biao_rig biao_rig1">
          <div>
            〒181-0013 東京都三鷹市下連雀<span class="huan"
              >7-13-9三鷹シャインパークス</span
            >
          </div>
        </div>
      </div> -->
      <!-- <div class="biao biao1">
        <div class="biao_le biao_le_3">{{ $t("home.h14") }}</div>
        <div class="biao_rig biao_rig_3">
          <div>{{ $t("home.h15") }}</div>
          <div>{{ $t("home.h16") }}</div>
        </div>
      </div>
      <div class="biao biao1">
        <div class="biao_le biao4">{{ $t("home.h17") }}</div>
        <div class="biao_rig biao4_re">
          <div>{{ $t("home.h18") }}</div>
        </div>
      </div> -->
      <div class="gaiyao_title">日本職場体験</div>
      <div class="img_box">
        <div class="im_list">
          <img @click="toshiji" src="../assets/h1.jpg" alt="" />
          <div>{{ $t("home.h20") }}</div>
        </div>
        <div class="im_list">
          <img @click="toshiji" src="../assets/h2.jpg" alt="" />
          <div>{{ $t("home.h21") }}</div>
        </div>
        <div class="im_list">
          <img @click="toshiji" src="../assets/h3.jpg" alt="" />
          <div>{{ $t("home.h22") }}</div>
        </div>
      </div>
      <!-- <div class="daxue" ref="carousel">
        <div class="carousel-inner" :style="innerStyles">
          <img src="../assets/d1.png" alt="" />
          <img src="../assets/d2.png" alt="" />
          <img src="../assets/d3.png" alt="" />
          <img src="../assets/d4.png" alt="" />
          <img src="../assets/d5.png" alt="" />
          <img src="../assets/d6.png" alt="" />
          <img src="../assets/d7.png" alt="" />
          <img src="../assets/d8.png" alt="" />
          <img src="../assets/d9.png" alt="" />
          <img src="../assets/d10.png" alt="" />
          <img src="../assets/d11.png" alt="" />
          <img src="../assets/d12.png" alt="" />
          <img src="../assets/d13.png" alt="" />
          <img src="../assets/d14.png" alt="" />
          <img src="../assets/d15.png" alt="" />

          <img src="../assets/d1.png" alt="" />
        </div>
      </div> -->
      <div class="title2">連携機関</div>
      <div id="app">
        <div class="carousel" ref="carousel">
          <div class="carousel-inner" :style="innerStyles">
            <!-- 克隆最后一张图片到最前面 -->
            <div class="carousel-item">
              <img :src="images[images.length - 1].src" alt="" />
              <p style="color: #153266">
                {{ images[images.length - 1].title }}
              </p>
            </div>
            <!-- 原始图片列表 -->
            <div
              v-for="(image, index) in images"
              :key="index"
              class="carousel-item"
            >
              <img :src="image.src" alt="" />
              <p style="color: #153266">{{ image.title }}</p>
            </div>
            <!-- 克隆第一张图片到最后面 -->
            <div class="carousel-item">
              <img :src="images[0].src" alt="" />
              <p style="color: #153266">{{ images[0].title }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="foo_con">
          <div class="fo_le">
            <img src="../assets/logo2.png" alt="" />
            <div class="fo_le_re">
              <div class="fo_top">{{ $t("home.h23") }}</div>
              <div class="fo_le_re_bo">
                <div @click="goToTop">{{ $t("home.h24") }}</div>
                <div @click="toGaiyao">{{ $t("home.h25") }}</div>
                <div @click="tojieshao">{{ $t("home.h26") }}</div>
                <div @click="toshiji">{{ $t("home.h27") }}</div>
              </div>
            </div>
          </div>
          <div class="fo_re" @click="towenxun">{{ $t("home.h28") }}</div>
        </div>
        <div class="beian">{{ $t("home.h29") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  props: {
    msg: String,
  },
  data() {
    return {
      value1: 0,
      option1: [
        { text: "中文", value: 0 },
        { text: "日本語", value: 1 },
      ],
      selectedOption: "日本語",
      currentIndex: 1, // 开始于1是因为我们有一个额外的首图副本
      intervalId: null,
      images: [
        { src: require("@/assets/d1.png"), title: "云南大学" },
        { src: require("@/assets/d2.png"), title: "云南师范大学" },
        { src: require("@/assets/d3.png"), title: "四川外国语大学" },
        { src: require("@/assets/d4.png"), title: "北京第二外国语学院" },
        { src: require("@/assets/d5.png"), title: "海南大学" },
        { src: require("@/assets/d6.png"), title: "兰州大学" },
        { src: require("@/assets/d7.png"), title: "东北大学" },
        { src: require("@/assets/d8.png"), title: "贵州大学" },
        { src: require("@/assets/d9.png"), title: "广西大学" },
        { src: require("@/assets/d10.png"), title: "广西师范大学" },
        { src: require("@/assets/d11.png"), title: "青海师范大学" },
        { src: require("@/assets/d12.png"), title: "青海民族大学" },
        { src: require("@/assets/d13.png"), title: "宁夏大学" },
        { src: require("@/assets/d14.png"), title: "西北师范大学" },
        { src: require("@/assets/d15.png"), title: "南宁师范大学" },
        // 添加更多图片...
      ],
      // images: [
      //   require("@/assets/d1.png"),
      //   require("@/assets/d2.png"),
      //   require("@/assets/d3.png"),
      //   require("@/assets/d4.png"),
      //   require("@/assets/d5.png"),
      //   require("@/assets/d6.png"),
      //   require("@/assets/d7.png"),
      //   require("@/assets/d8.png"),
      //   require("@/assets/d9.png"),
      //   require("@/assets/d10.png"),
      //   require("@/assets/d11.png"),
      //   require("@/assets/d12.png"),
      //   require("@/assets/d13.png"),
      //   require("@/assets/d14.png"),
      //   require("@/assets/d15.png"),
      // ],
      // titles: [
      //   "云南大学",
      //   "云南师范大学",
      //   "四川外国语大学",
      //   "北京第二外国语学院",
      //   "海南大学",
      //   "兰州大学",
      //   "东北大学",
      //   "贵州大学",
      //   "广西大学",
      //   "广西师范大学",
      //   "青海师范大学",
      //   "青海民族大学",
      //   "宁夏大学",
      //   "西北师范大学",
      //   "南宁师范大学",
      // ],
    };
  },
  computed: {
    innerStyles() {
      return {
        "--total-items": this.images.length,
      };
    },
  },
  // watch: {
  //   currentIndex(newValue) {
  //     if (newValue >= this.imagesLength) {
  //       this.$nextTick(() => {
  //         this.currentIndex = 0;
  //       });
  //     }
  //   },
  // },
  mounted() {
    const carouselInner = this.$refs.carousel.querySelector(".carousel-inner");
    // const itemWidth = 100 / (this.images.length + 2);
    carouselInner.style.animationDuration = `${(this.images.length + 2) * 2}s`; // 调整动画总时长
  },
  methods: {
    goToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
    },
    handleChange(event) {
      if (event.target.value == "日本語") {
        this.$i18n.locale = "ja";
      } else if (event.target.value == "中文") {
        this.$i18n.locale = "zh";
      }
    },
    toHome() {
      this.$router.push({ name: "HomePage" });
    },
    toGaiyao() {
      this.$router.push({ name: "GaiYao" });
    },
    tojieshao() {
      this.$router.push({ name: "JieShao" });
    },
    toshiji() {
      this.$router.push({ name: "ShiJi" });
    },
    towenxun() {
      this.$router.push({ name: "WenXun" });
    },
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId); // 清除定时器防止内存泄漏
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 700px) {
  .con_box,
  .top_box,
  .im_list,
  .foo_con,
  .top_img,
  .biao {
    width: 100% !important;
  }
  .top_img img {
    width: 100% !important;
  }
  .top_box,
  .img_box,
  .fo_le,
  .foo_con {
    flex-wrap: wrap;
    margin-bottom: 20px !important;
  }
  .biao_le_3 {
    width: 165px !important;
  }
  .biao_rig1 {
    margin-left: -34px !important;
  }
  .biao_le_1 {
    width: 111px !important;
  }
  .biao_rig_1 {
    margin-left: -10px !important;
  }
  .huan {
    display: block;
  }
  .HomePage {
    padding: 0 !important;
  }
  .hudong_title {
    /* width: 50% !important; */
    padding: 0 30px !important;
    font-size: 16px !important;
    height: 40px !important;
  }
  .biao_rig_3 {
    margin-left: -30px !important;
  }
  .biao_rig {
    text-align: left !important;
  }
  .biao_le2 {
    margin-left: 0 !important;
  }
  .top_rig {
    gap: 10px !important;
    margin-top: 15px !important;
    font-size: 14px;
    margin: 0 auto;
  }
  .fo_le {
    justify-content: center;
  }
  .fo_le_re {
    align-items: center !important;
  }
  .im_list {
    margin-bottom: 20px !important;
  }
  .footer {
    padding-top: 0 !important;
  }
  .fo_le img {
    width: 100px !important;
    height: 100px !important;
  }
  .foo_con {
    flex-direction: column !important;
  }
  .fo_le {
    flex-direction: column !important;
    align-items: center !important;
    gap: 0 !important;
  }
  .fo_le_re_bo {
    margin-top: 20px !important;
  }
  .beian {
    margin-top: 0 !important;
  }
  .biao4 {
    margin-left: -10px !important;
  }
  .biao4_re {
    margin-left: -34px !important;
  }
  .meng_h1 {
    top: 46px !important;
    width: 83% !important;
    left: 8% !important;
  }
  .meng_h1 div {
    height: 90px !important;
    margin-bottom: 23px !important;
  }
  .meng_h2 div {
    width: 55px !important;
    height: 37px !important;
  }
  .meng_h2 :nth-child(1),
  .meng_h2 :nth-child(8) {
    left: calc(50% - 27px) !important;
  }
  .meng_h2 :nth-child(9) {
    width: 60px !important;
    height: 60px !important;
    left: calc(50% - 30px) !important;
  }
  .carousel img {
    width: 90px !important;
    height: 81px !important;
  }
  .h_title {
    justify-content: center !important;
    width: 100% !important;
  }
  .h_title {
    gap: 10px !important;
  }
  .h_title :nth-child(1) {
    display: none !important;
  }
  .im_list img {
    height: 200px !important;
    width: 70% !important;
  }
  .carousel-item p {
    display: none !important;
  }
  .carousel {
    margin-bottom: 30px !important;
  }
}
.title2 {
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 20px;
}
.daxue {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  overflow: hidden;
  width: 100%;
}
.carousel img {
  width: 230px;
  height: 208px;
}
.carousel {
  overflow: hidden;
  width: 100%;
}

.carousel-inner {
  display: flex;
  animation: slide 30s linear infinite; /* 根据实际需要调整时间 */
}

.carousel-item {
  box-sizing: border-box;
}

@keyframes slide {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-100% * (1 + 1 / var(--total-items))));
  }
}
.img_h1 {
  width: 100%;
  position: relative;
}
.img_h2 {
  width: 100%;
  position: relative;
}
.img_h2 img {
  width: 100%;
}
.meng_h2 {
  position: absolute;
  width: 74%;
  top: 0px;
  left: 13%;
  /* height: 722px; */
  /* background-color: red; */
  opacity: 0.3;
  height: 100%;
}
.meng_h2 div {
  /* background-color: blue; */
  cursor: pointer;
  position: absolute;
  border-radius: 100%;
  width: 200px;
  height: 137px;
}
.meng_h2 :nth-child(1) {
  top: 5%;
  left: calc(50% - 100px);
}
.meng_h2 :nth-child(2) {
  top: 15%;
  left: 12%;
}
.meng_h2 :nth-child(3) {
  top: 15%;
  right: 14%;
}
.meng_h2 :nth-child(4) {
  top: 41%;
  left: 0;
}
.meng_h2 :nth-child(5) {
  top: 41%;
  right: 0;
}
.meng_h2 :nth-child(6) {
  top: 67%;
  left: 12%;
}
.meng_h2 :nth-child(7) {
  top: 67%;
  right: 14%;
}
.meng_h2 :nth-child(8) {
  top: 76%;
  left: calc(50% - 100px);
}
.meng_h2 :nth-child(9) {
  top: 35%;
  left: calc(50% - 111px);
  width: 223px;
  height: 223px;
  border-radius: 100%;
}
.meng_h1 {
  position: absolute;
  width: 84%;
  top: 160px;
  left: 8%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.meng_h1 div {
  width: 47%;
  height: 340px;
  /* background-color: red; */
  margin-bottom: 27px;
  cursor: pointer;
}
.img_h1 img {
  width: 90%;
}
.img_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 50px;
}
.im_list {
  width: 32%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  font-size: 20px;
}
.im_list img {
  width: 100%;
  height: 300px;
  cursor: pointer;
}
.biao {
  width: 85%;
  margin: 0 auto;
  display: flex;
  gap: 50px;
  align-items: center;
  padding-top: 30px;
  padding-bottom: 30px;
  padding-left: 10px;
  box-sizing: border-box;
  border-top: 2px solid #000;
  border-bottom: 2px solid #000;
}
.biao1 {
  border-top: none !important;
}
.biao_le {
  font-size: 20px;
  width: 100px;
}
.biao_rig {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: baseline;
}
.biao_le1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: baseline;
}
.biao_le2 {
  margin-left: 10px;
  width: 90px;
}

.bg_img {
  width: 100%;
}
.bg_img img {
  width: 100%;
}
.hudong_title {
  /* width: 20%; */
  font-size: 27px;
  height: 60px;
  border-radius: 30px;
  background-color: #1e386b;
  padding: 0 100px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.h_title {
  display: flex;
  gap: 10px;
  margin: 30px auto;
  align-items: center;
  width: 50%;
}
.gaiyao_title {
  color: #000;
  text-align: center;
  margin: 30px auto;
  font-size: 24px;
  font-weight: 600;
}
/* css */
.HomePage {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}
.con_box {
  width: 90%;
  margin: 0 auto;
}
.top_box {
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top_img {
  display: flex;
  gap: 0px;
  align-items: center;
}

.name_box {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: baseline;
}
.name_box :nth-child(1) {
  font-size: 22px;
  font-weight: 600;
}
.top_rig {
  display: flex;
  gap: 20px;
  align-items: center;
}
.HomePage >>> .van-dropdown-menu__bar {
  width: 115px;
  height: 40px;
  /* box-shadow: none; */
}
.HomePage >>> .van-dropdown-item__content {
  /* right: 222px !important; */
  width: 116px;
}
.HomePage >>> .van-popup--top {
  right: 222px !important;
  left: auto;
}
.van-popup--top {
  right: 222px;
  left: auto;
}
.tab {
  cursor: pointer;
}
.footer {
  background-color: #153266;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 40px;
  box-sizing: border-box;
}
.fo_le_re_bo div {
  cursor: pointer;
}
.foo_con {
  width: 80%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0 auto;
}
.fo_le {
  display: flex;
  gap: 40px;
}
.fo_le img {
  width: 200px;
  height: 200px;
}
.fo_le_re {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: baseline;
}
.fo_top {
  font-size: 22px;
  font-weight: 600;
  color: #fff;
}
.fo_le_re_bo {
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #fff;
}
.fo_re {
  color: #fff;
  cursor: pointer;
}
.beian {
  text-align: center;
  margin-top: 70px;
  /* margin-bottom: 10px; */
  color: #fff;
}
select {
  width: 100px;
  height: 40px;
  box-shadow: 1px 2px 3px #999;
  border: none;
  text-align: center;
  outline: none;
}
</style>
